import React, { FC, useCallback } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';
import { Keyboard, TouchableOpacity } from 'react-native';

import { theme } from 'styles/configure-theme';

import { StoreLocatorViews } from '../../types';

import { IToggleViewButtonProps, VIEW_MESSAGE_ID_MAP } from './types';

export const ToggleViewButton: FC<React.PropsWithChildren<IToggleViewButtonProps>> = ({
  currentView,
  updateStoreLocatorView,
}) => {
  const { formatMessage } = useIntl();

  const handleToggleLocatorViewClick = useCallback(() => {
    const newView =
      currentView === StoreLocatorViews.LIST_VIEW
        ? StoreLocatorViews.MAP_VIEW
        : StoreLocatorViews.LIST_VIEW;
    updateStoreLocatorView(newView);
    Keyboard.dismiss();
  }, [currentView, updateStoreLocatorView]);

  const currentViewText = formatMessage({ id: VIEW_MESSAGE_ID_MAP[currentView] });
  // display map option when they are on the list view
  return (
    <TouchableOpacity
      onPress={handleToggleLocatorViewClick}
      testID="toggle-view-button"
      accessibilityLabel={currentViewText}
    >
      <Icon
        variant={currentView === StoreLocatorViews.LIST_VIEW ? 'map' : 'list'}
        color={theme.token('text-button-reversed')}
        aria-hidden
      />
    </TouchableOpacity>
  );
};
